/*********************************************************************************\
*
* THIS COMPONENT USES INLINE CSS, BECAUSE GOOGLE MAP DOESN'T LIKE US USING CLASS
* TO CONTROL THIS COMPONENT ON TOP OF GOOGLE MAP.
*
\*********************************************************************************/

import React from 'react';
import { Offline } from 'common/components';
import { offline as OfflineIcon } from 'common/svg/icons';

export const OfflineOverlay = () => (
  <Offline>
    <div
      style={{
        height: '100%',
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        justifyContent: 'center',
        flexDirection: 'column',
        display: 'flex',
      }}
    >
      <div
        style={{
          margin: '0 auto',
          textAlign: 'center',
        }}
      >
        <div>
          <OfflineIcon />
          <a
            style={{
              fontSize: '24px',
              fontFamily: 'Univers LT Extra Black Obliq, sans-serif',
              textDecoration: 'none',
              color: 'white',
              marginLeft: '1rem',
              cursor: 'default',
            }}
          >
            MAP OFFLINE
          </a>
        </div>
        <div
          style={{
            fontSize: '16px',
            fontFamily: 'Univers LT Bold, sans-serif',
            textDecoration: 'none',
            color: 'white',
            marginTop: '2rem',
          }}
        >
          You must be connected to the internet to view the map.
        </div>
      </div>
    </div>
  </Offline>
);



// WEBPACK FOOTER //
// ./src/common/components/MapComponent/OfflineOverlay.js